function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 5,
  fill: "#F472D0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 18.9h-.68l-2 1.8h1.91L25 22.5H11l1.78-1.8h2.05l-2-1.8H12l-3 2.7v3.6c0 .99.89 1.8 1.99 1.8H25c1.1 0 2-.8 2-1.8v-3.6l-3-2.7zm-1-4.544l-4.95 4.455-3.54-3.186 4.95-4.455L23 14.356zm-4.24-5.094l-6.37 5.733a.834.834 0 000 1.269l4.95 4.454c.39.351 1.02.351 1.41 0l6.36-5.723a.834.834 0 000-1.27l-4.95-4.454c-.38-.36-1.01-.36-1.4-.009z",
  fill: "#FCEDF8"
});

function SvgProposal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgProposal;